<template>


    <nav class="cf-menutop" ref="menuroot">
        <div class="cf-menu-inner">

            <router-link to="/caisse" class="cf-menutop__brand">
                <i class="ri-cash-line"></i>
            </router-link>

            <!-- Bascule mobile -->
            <button @click="toggleNavbar" type="button" class="cf-menu-burger" :aria-expanded="isNavbarOpen.toString()">
                <span class="sr-only">Ouvrir le menu</span>
                <i class="ri-menu-line"></i>
            </button>

            <div :class="{ 'hidden': !isNavbarOpen, 'block': isNavbarOpen }" class="cf-menu-collapse" id="navbar-dropdown">
                <ul class="cf-menu-list">

                    <template v-if="$store.state.ouverturedelacaisse===1">

                        <li>
                            <button type="button" class="cf-menu-btn" @click="btnbeneficiaire(); openMenu = null; isNavbarOpen = false">
                                <i class="ri-user-star-line cf-menu-icon"></i> Bénéficiaire
                            </button>
                        </li>
                        <li>
                            <button type="button" class="cf-menu-btn">
                                <i class="ri-file-chart-line cf-menu-icon"></i> Rapport de caisse
                            </button>
                        </li>
                        <li>
                            <button type="button" class="cf-menu-btn" @click="btnmoadalfermercaisse(); openMenu = null; isNavbarOpen = false">
                                <i class="ri-lock-2-line cf-menu-icon"></i> Fermer la caisse
                            </button>
                        </li>

                    </template>

                    <template v-else>

                        <li>
                            <button type="button" class="cf-menu-btn" @click="btnmoadalouverturecaisse(); openMenu = null; isNavbarOpen = false">
                                <i class="ri-safe-2-line cf-menu-icon"></i> Ouvrir la caisse
                            </button>
                        </li>

                    </template>


                    <!-- Rapports / Editions -->
                    <li v-if="accesviewrapporteditioncaisse" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'rap' }" @click="toggleMenu('rap')">
                            <i class="ri-bar-chart-box-line cf-menu-icon"></i> Rapports / Editions
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'rap' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'rap'" class="cf-menu-pop cf-menu-scroll">
                                <button type="button" class="cf-menu-item" @click="btnmodalpointdelacaisse(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-focus-3-line"></i> Point de la caisse
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalbrouillarddecaisse(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-draft-line"></i> Brouillard de caisse
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalpointdelacaisse6(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-line-chart-line"></i> Analyse de caisse
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodaldepotclientautre('depot'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-hand-coin-line"></i> Liste des dépôt client effectuées au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodaldepotclientautre('reference'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-refund-2-line"></i> Liste des retours de fond de caisse effectuées au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodaldepotclientautre('depense'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-wallet-3-line"></i> Liste des dépenses effectuées au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodallistedesfacturactionsalacaisse('FVC'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-file-list-3-line"></i> Listes des facturations effectuées au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalrecapitulatifca(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-pie-chart-line"></i> Analyse du chiffre d’affaires au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalpointdelacaisse5(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-file-chart-2-line"></i> Synthèse de caisse au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalapprocaissebanque('d1'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-bank-line"></i> Listes des approvisionnements par la banque / par la caisse au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalreglementfacture(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-bill-line"></i> Listes des factures par réglements au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalreglementclientfournisseur('fournisseur'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-truck-line"></i> Listes des réglements fournisseur au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalreglementclientfournisseur('client'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-user-line"></i> Listes des réglements client au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalreglementclientfournisseur('vfournisseur'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-truck-line"></i> Listes des avances fournisseur au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalreglementclientfournisseur('vclient'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-user-line"></i> Listes des avances client au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodaloperationbanquaire('bop1'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-exchange-line"></i> Listes des opérations bancaire au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalapprocaissebanque('d2'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-safe-line"></i> Listes des dépôts de fond de banque / fond de caisse au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodaloperationbanquaire('Rop1'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-file-paper-2-line"></i> Liste des bordereaux de banque au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalallreglementbcd(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-list-check"></i> Liste des réglements BCD interne à la caisse au cours d'une période
                                </button>
                                <button type="button" class="cf-menu-item cf-menu-item--muted" disabled>
                                    <i class="ri-file-list-2-line"></i> Etat des facturations de vente détaillée au cours d'une période
                                </button>
                            </div>
                        </transition>
                    </li>


                    <!-- Utilitaires -->
                    <li v-if="accesviewutilitairecaisse" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'uti' }" @click="toggleMenu('uti')">
                            <i class="ri-tools-line cf-menu-icon"></i> Utilitaires
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'uti' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'uti'" class="cf-menu-pop cf-menu-scroll">
                                <button type="button" class="cf-menu-item" @click="btnutilitairemiseajourpointsurletatdepaiement(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-refresh-line"></i> Caisse / Mise à jour des points de caisse sur les états de paiement
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnutilitairemiseajouretatdepaiement(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-refresh-line"></i> Caisse / Mise à jour des états de paiement
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnutilitairemiseajourfactureannulle(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-close-circle-line"></i> Caisse / Actualisation des factures annulées
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnutilitaicorrectiontransfertdecaisse(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-swap-box-line"></i> Caisse / Correction liers au annulation des operations de transfert de caisse mal effectuées
                                </button>
                            </div>
                        </transition>
                    </li>

                </ul>
            </div>
        </div>
    </nav>

    <moadalouverturecaisse ref="moadalouverturecaisse"></moadalouverturecaisse>
    <modalpointdelacaisse ref="modalpointdelacaisse"></modalpointdelacaisse>
    <modaldepotclientautre ref="modaldepotclientautre"></modaldepotclientautre>
    <modallistedesfacturactionsalacaisse ref="modallistedesfacturactionsalacaisse"></modallistedesfacturactionsalacaisse>
    <modalapprocaissebanque ref="modalapprocaissebanque"></modalapprocaissebanque>
    <modalreglementfacture ref="modalreglementfacture"></modalreglementfacture>
    <modalreglementclientfournisseur ref="modalreglementclientfournisseur"></modalreglementclientfournisseur>
    <modaloperationbanquaire ref="modaloperationbanquaire"></modaloperationbanquaire>
    <modalallreglementbcd ref="modalallreglementbcd"></modalallreglementbcd>
    <modalbeneficiaire ref="modalbeneficiaire"></modalbeneficiaire>
    <modalrecapitulatifca ref="modalrecapitulatifca"></modalrecapitulatifca>
    <modalbrouillarddecaisse ref="modalbrouillarddecaisse"></modalbrouillarddecaisse>

    <fermerturecaisseouinon ref="fermerturecaisseouinon" ></fermerturecaisseouinon>


    <utilitairemiseajourpointsurletatdepaiement ref="utilitairemiseajourpointsurletatdepaiement"></utilitairemiseajourpointsurletatdepaiement>

    <utilitairemiseajouretatdepaiement ref="utilitairemiseajouretatdepaiement"></utilitairemiseajouretatdepaiement>
    <utilitairemiseajourfactureannulle ref="utilitairemiseajourfactureannulle"></utilitairemiseajourfactureannulle>
    <utilitaicorrectiontransfertdecaisseapproc ref="utilitaicorrectiontransfertdecaisseapproc"></utilitaicorrectiontransfertdecaisseapproc>

    <modalrapportdecaisse5 ref="modalrapportdecaisse5" ></modalrapportdecaisse5>
  <modalrapportdecaisse6 ref="modalrapportdecaisse6"></modalrapportdecaisse6>
</template>


<script>
    import moadalouverturecaisse from "@/components/views/pages/caisse/moadal_ouverturecaisse";
    import modalpointdelacaisse from "@/components/views/pages/caisse/rapport/modal_pointdelacaisse";
    import modalrecapitulatifca from "@/components/views/pages/caisse/rapport/modal_recapitulatifCA";
    import modaldepotclientautre from "@/components/views/pages/caisse/rapport/modal_depotclientautre";
    import modallistedesfacturactionsalacaisse from "@/components/views/pages/caisse/rapport/modal_listedesfacturactionsalacaissev2.vue";
    //import modallistedesfacturactionsalacaisse from "@/components/views/pages/caisse/rapport/modal_listedesfacturactionsalacaisse";
    import modalapprocaissebanque from "@/components/views/pages/caisse/rapport/modal_approcaissebanque";
    import modalreglementfacture from "@/components/views/pages/caisse/rapport/modal_reglementfacture";
    import modalreglementclientfournisseur from "@/components/views/pages/caisse/rapport/modal_reglementclientfournisseur";
    import modaloperationbanquaire from "@/components/views/pages/caisse/rapport/modal_operationbanquaire";
    import modalallreglementbcd from "@/components/views/pages/caisse/rapport/modal_allreglementbcd";
    import modalbrouillarddecaisse from "@/components/views/pages/caisse/rapport/modal_brouillarddecaisse";
    import modalbeneficiaire from "@/components/views/pages/caisse/beneficiaire/index";
    import fermerturecaisseouinon from "@/components/views/pages/caisse/fermerturecaisseouinon";

    import utilitairemiseajouretatdepaiement
        from "@/components/views/pages/setting/utilitaires/caisse/modal_miseajouretatdepaiement";


    import utilitairemiseajourfactureannulle
        from "@/components/views/pages/setting/utilitaires/caisse/modal_miseajourfactureannulle.vue";

    import utilitaicorrectiontransfertdecaisseapproc
        from "@/components/views/pages/setting/utilitaires/caisse/modal_correctiondestransfertdecaisseAPPROC.vue";


    import utilitairemiseajourpointsurletatdepaiement
        from "@/components/views/pages/setting/utilitaires/caisse/modal_miseajourPointsurletatdepaiement";
    import modalrapportdecaisse5 from "@/components/views/pages/caisse/facturation/5/rapport/modal_rapportdecaisse_5";
    import modalrapportdecaisse6
      from "@/components/views/pages/caisse/facturation/5/rapport/modal_rapportdecaisse_6v2.vue";


    export default {
        /* eslint-disable */
        name: "mymenu",
        props: {
            accesviewrapporteditioncaisse: {
                type: Boolean,
                required: true
            },
            accesviewutilitairecaisse: {
                type: Boolean,
                required: true
            }
        },
        components:{
            fermerturecaisseouinon,
            moadalouverturecaisse,
            modalpointdelacaisse,
            modaldepotclientautre,
            modallistedesfacturactionsalacaisse,
            modalapprocaissebanque,
            modalreglementfacture,
            modalreglementclientfournisseur,
            modaloperationbanquaire,
            modalallreglementbcd,
            modalbeneficiaire,
            modalrecapitulatifca,
            modalbrouillarddecaisse,
          modalrapportdecaisse6,
            utilitairemiseajouretatdepaiement,
          utilitairemiseajourfactureannulle,
          utilitaicorrectiontransfertdecaisseapproc,
            utilitairemiseajourpointsurletatdepaiement,
            modalrapportdecaisse5,
        },
        data() {
            return {
                isNavbarOpen: false,
                isDropdownOpen: true,
                openMenu: null
            };
        },
        methods: {




            
            btnutilitaicorrectiontransfertdecaisse(){



              let numpidcaisse="",datedouverture=""



              if (Object.keys(this.$store.state.caisseinfo).length>0){

                numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

              }
              else{


                numpidcaisse=this.$store.state.caisseencour,
                    datedouverture=""


              }




                this.$refs.utilitaicorrectiontransfertdecaisseapproc.show(numpidcaisse,datedouverture);
            },




            btnutilitairemiseajourpointsurletatdepaiement(){



              let numpidcaisse="",datedouverture=""



              if (Object.keys(this.$store.state.caisseinfo).length>0){

                numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

              }
              else{


                numpidcaisse=this.$store.state.caisseencour,
                    datedouverture=""


              }



              this.$refs.utilitairemiseajourpointsurletatdepaiement.show(numpidcaisse,datedouverture);
            },

            btnutilitairemiseajouretatdepaiement(){



              let numpidcaisse="",datedouverture=""



              if (Object.keys(this.$store.state.caisseinfo).length>0){

                numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

              }
              else{


                numpidcaisse=this.$store.state.caisseencour,
                    datedouverture=""


              }




                this.$refs.utilitairemiseajouretatdepaiement.show(numpidcaisse,datedouverture);
            },


            btnutilitairemiseajourfactureannulle(){



              let numpidcaisse="",datedouverture=""



              if (Object.keys(this.$store.state.caisseinfo).length>0){

                numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

              }
              else{


                numpidcaisse=this.$store.state.caisseencour,
                    datedouverture=""


              }




                this.$refs.utilitairemiseajourfactureannulle.show(numpidcaisse,datedouverture);
            },



            toggleNavbar() {
                this.isNavbarOpen = !this.isNavbarOpen;
            },
            toggleDropdown() {


                this.isDropdownOpen = !this.isDropdownOpen;

            },

            // Plumbing menus manuels (remplace Preline hs-dropdown)
            toggleMenu(name) {
                this.openMenu = this.openMenu === name ? null : name;
            },
            handleGlobalClick(e) {
                const root = this.$refs.menuroot;
                if (root && !root.contains(e.target)) {
                    this.openMenu = null;
                }
            },



            btnmoadalfermercaisse(){


                this.$refs.fermerturecaisseouinon.show(this.accesviewrapporteditioncaisse);

            },


            btnmodalrecapitulatifca(){

                let titlemodal="",numpidcaisse="",datedouverture=""

                // if (value==='FVC'){}

                titlemodal="Analyse du chiffre d’affaires"


                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                        datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }


                this.$refs.modalrecapitulatifca.show(titlemodal,numpidcaisse,datedouverture);

            },


            btnmodalpointdelacaisse5(){
                let titlemodal="",numpidcaisse="",datedouverture=""


                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                        datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                //this.$refs.modalpointdelacaisse5.show("POINT DE LA CAISSE",numpidcaisse,datedouverture,'FVC',this.isNormalisationEtat);
                this.$refs.modalrapportdecaisse5.show("RAPPORT DE CAISSE",numpidcaisse,datedouverture,'FVC',this.isNormalisationEtat);


            },




            btnbeneficiaire(){

                let titlemodal="Liste des bénéficiaires"

                this.$refs.modalbeneficiaire.show(titlemodal);
            },

            btnmoadalouverturecaisse(){

                let titlemodal="Ouverture de la caisse à la date du "+this.$store.state.appserverdate

                this.$refs.moadalouverturecaisse.show(titlemodal);
            },

            btnmodalpointdelacaisse(){

                let titlemodal="POINT DE LA CAISSE",numpidcaisse="",datedouverture=""



                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modalpointdelacaisse.show(numpidcaisse,datedouverture);
            },

            btnmodaldepotclientautre(value){

                let titlemodal="",numpidcaisse="",datedouverture=""

                if (value==='depot'){titlemodal="LISTE DES DÉPÔTS CLIENTS"}
                if (value==='reference'){titlemodal="LISTE DES RETOURS DE FONDS DE CAISSE"}
                if (value==='depense'){titlemodal="LISTE DES DÉPENSES"}



                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modaldepotclientautre.show(titlemodal,numpidcaisse,datedouverture,value);
            },



            btnmodallistedesfacturactionsalacaisse(value){

                let titlemodal="",numpidcaisse="",datedouverture=""

                if (value==='FVC'){titlemodal="LISTE DES FACTURATIONS AU COMPTOIRE"}



                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modallistedesfacturactionsalacaisse.show(titlemodal,numpidcaisse,datedouverture,value);
            },




            btnmodalbrouillarddecaisse(){

                let titlemodal="BROUILLAR DE CAISSE",numpidcaisse="",datedouverture=""


                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modalbrouillarddecaisse.show(titlemodal,numpidcaisse,datedouverture);
            },


          btnmodalpointdelacaisse6() {


            let  numpidcaisse="",datedouverture=""


            if (Object.keys(this.$store.state.caisseinfo).length>0){

              numpidcaisse=this.$store.state.caisseinfo.cpid,
                  datedouverture=this.$store.state.caisseinfo.dateouverture

            }
            else{


              numpidcaisse=this.$store.state.caisseencour,
                  datedouverture=""


            }




            this.$refs.modalrapportdecaisse6.show("ANALYSE DE CAISSE", numpidcaisse, datedouverture, 'FVC', this.isNormalisationEtat);


          },




            btnmodalapprocaissebanque(value){

                let titlemodal="",numpidcaisse="",datedouverture=""


                    if (value==="d1"){
                        titlemodal="LISTE DES APPROVISIONNEMENTS"
                    }
                    else{
                        titlemodal="LISTE DES DEPÔTS"
                    }




                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modalapprocaissebanque.show(titlemodal,numpidcaisse,datedouverture,value);
            },

            btnmodalreglementfacture(){

                let titlemodal="",numpidcaisse="",datedouverture=""


                titlemodal="LISTE DES REGLEMENTS FACTURE"


                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modalreglementfacture.show(titlemodal,numpidcaisse,datedouverture);
            },

            btnmodalreglementclientfournisseur(value){

                let titlemodal="",numpidcaisse="",datedouverture=""


                if (value==="fournisseur"){  titlemodal="LISTE DES REGLEMENTS FOURNISSEURS"}
                if (value==="client"){  titlemodal="LISTE DES REGLEMENTS CLIENTS"}
                if (value==="vfournisseur"){  titlemodal="LISTE DES AVANCES FOURNISSEURS"}
                if (value==="vclient"){  titlemodal="LISTE DES AVANCES CLIENTS"}





                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modalreglementclientfournisseur.show(titlemodal,numpidcaisse,datedouverture,value);
            },

            btnmodaloperationbanquaire(value){

                let titlemodal="",numpidcaisse="",datedouverture=""


                /*if (value==="fournisseur"){  titlemodal="LISTE DES REGLEMENTS FOURNISSEURS"}
                if (value==="client"){  titlemodal="LISTE DES REGLEMENTS CLIENTS"}
                if (value==="vfournisseur"){  titlemodal="LISTE DES AVANCES FOURNISSEURS"}
                if (value==="vclient"){  titlemodal="LISTE DES AVANCES CLIENTS"}*/



                if (value==="bop1"){ titlemodal="LISTE DES OPERATIONS BANCAIRES"}
                if (value==="Rop1"){ titlemodal="LISTE DES BORDEREAUX DE BANQUE"}



                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modaloperationbanquaire.show(titlemodal,numpidcaisse,datedouverture,value);
            },

            btnmodalallreglementbcd(){

                let titlemodal="LISTE DES REGLEMENTS BCD INTERNE",numpidcaisse="",datedouverture=""


                /*if (value==="bop1"){ titlemodal="LISTE DES OPERATIONS BANCAIRES"}
                if (value==="Rop1"){ titlemodal="LISTE DES BORDEREAUX DE BANQUE"}*/



                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                    datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modalallreglementbcd.show(titlemodal,numpidcaisse,datedouverture);
            },




        },

        mounted() {
            document.addEventListener('click', this.handleGlobalClick);
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleGlobalClick);
        }
    };
</script>

<style scoped>
    /* Charte cf-/ds- : barre de menu du module Caisse (light-only) */
    .cf-menutop {
        margin-top: 4% !important;
        background: #fff;
        border: 1px solid rgb(var(--default-border));
        border-radius: var(--cf-radius);
        box-shadow: var(--cf-shadow-sm);
    }
    @media screen and (max-width: 800px) { .cf-menutop { margin-top: 12.5% !important; } }

    .cf-menu-inner {
        display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem 1rem;
        padding: 0.6rem 1rem; max-width: 1280px; margin: 0 auto;
    }
    .cf-menutop__brand {
        display: inline-flex; align-items: center; gap: 0.5rem;
        font-weight: 700; font-size: 0.95rem; letter-spacing: -0.01em;
        color: rgb(var(--primary)); text-decoration: none;
    }
    .cf-menutop__brand i { font-size: 1.15rem; }

    .cf-menu-burger {
        margin-left: auto; height: 38px; width: 38px; border: 1px solid var(--cf-border);
        border-radius: var(--cf-radius-sm); background: #fff; color: var(--cf-muted);
        display: inline-flex; align-items: center; justify-content: center; font-size: 1.2rem; cursor: pointer;
    }
    .cf-menu-burger:hover { color: rgb(var(--primary)); border-color: rgb(var(--primary) / 0.35); }
    @media (min-width: 768px) { .cf-menu-burger { display: none; } }

    .cf-menu-collapse { width: 100%; }
    @media (min-width: 768px) { .cf-menu-collapse { display: block !important; width: auto; margin-left: auto; } }

    .cf-menu-list {
        display: flex; flex-direction: column; gap: 0.2rem; list-style: none;
        margin: 0.6rem 0 0; padding: 0;
    }
    @media (min-width: 768px) {
        .cf-menu-list { flex-direction: row; align-items: center; justify-content: flex-end; gap: 0.4rem; margin: 0; }
    }

    .cf-menu-dd { position: relative; }

    .cf-menu-btn {
        display: inline-flex; align-items: center; gap: 0.35rem; width: 100%;
        padding: 0.5rem 0.75rem; border-radius: var(--cf-radius-sm);
        font-weight: 600; font-size: 0.85rem; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: color 0.18s ease, background-color 0.18s ease;
    }
    @media (min-width: 768px) { .cf-menu-btn { width: auto; } }
    .cf-menu-btn:hover { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.07); }
    .cf-menu-btn--on { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.10); }
    .cf-menu-icon { color: rgb(var(--primary)); font-size: 1rem; }
    .cf-menu-caret { margin-left: auto; font-size: 0.9rem; color: var(--cf-faint); transition: transform 0.18s ease; }
    @media (min-width: 768px) { .cf-menu-caret { margin-left: 0.15rem; } }
    .cf-menu-caret--on { transform: rotate(180deg); color: rgb(var(--primary)); }

    .cf-menu-pop {
        display: flex; flex-direction: column; gap: 1px;
        margin: 0.15rem 0 0.35rem 0.75rem; padding: 0.35rem;
        border-left: 2px solid var(--cf-border);
    }
    @media (min-width: 768px) {
        .cf-menu-pop {
            position: absolute; top: calc(100% + 6px); right: 0; left: auto; z-index: 40;
            min-width: 260px; margin: 0; padding: 0.4rem;
            background: #fff; border: 1px solid var(--cf-border); border-left: 1px solid var(--cf-border);
            border-radius: var(--cf-radius); box-shadow: var(--cf-shadow-md);
        }
    }
    .cf-menu-scroll { max-height: 70vh; overflow-y: auto; }
    @media (min-width: 768px) { .cf-menu-scroll { min-width: 340px; } }

    .cf-menu-item {
        display: flex; align-items: center; gap: 0.5rem; width: 100%;
        padding: 0.5rem 0.65rem; border-radius: var(--cf-radius-sm);
        font-size: 0.82rem; font-weight: 500; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: background-color 0.15s ease, color 0.15s ease;
    }
    .cf-menu-item i { color: var(--cf-muted); font-size: 1rem; flex-shrink: 0; }
    .cf-menu-item:hover { background: rgb(var(--primary) / 0.08); color: rgb(var(--primary)); }
    .cf-menu-item:hover i { color: rgb(var(--primary)); }
    .cf-menu-item--muted { color: var(--cf-faint); cursor: not-allowed; }
    .cf-menu-item--muted:hover { background: transparent; color: var(--cf-faint); }
    .cf-menu-item--muted:hover i { color: var(--cf-muted); }

    .cf-menu-fade-enter-active, .cf-menu-fade-leave-active { transition: opacity 0.15s ease, transform 0.15s ease; }
    .cf-menu-fade-enter-from, .cf-menu-fade-leave-to { opacity: 0; transform: translateY(-4px); }

    .sr-only {
        position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
        overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
    }

    button:focus { outline: 0 !important; }
</style>